module.exports = __webpack_public_path__ + "img/reload-logo.99396b19.png";